<template lang="html">
  <div class="">
    <div
    class="display-toggle"
    @click="toggleDisplay">
      <!-- {{sceneDisplayMode}} -->
      <img v-if="sceneDisplayMode==2" src="/images/display-1.png" alt="">
      <img v-else src="/images/display-2.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  // components: {
  // },
  computed: {
    sceneDisplayMode () {
      return this.$store.state.sceneDisplayMode
    },
  },
  methods: {
    toggleDisplay () {
      let mode = this.sceneDisplayMode == 2 ? 1 : 2
      console.log("mode:", mode)
      this.$store.commit('setSceneDisplayMode', { mode })
    }
  }
}
</script>

<style lang="scss" scoped>
.display-toggle {
  @apply fixed top-16 right-1 mt-2 h-40 w-16 cursor-pointer z-50 pointer-events-auto select-none;
  @screen md {
    top: unset;
    @apply fixed bottom-0 right-4 h-64 w-24;
  }
  @apply opacity-80 transition;
  &:hover {
    @apply opacity-100;
  }
  img {
    @apply pointer-events-none;
  }
}
</style>
